import { LocalStorageService } from '@wolfgames/game-kit';
import type { GameConfig } from '../types';

const localStorageService = new LocalStorageService('clue-hunter');
const FTUE_VERSION_STORAGE_KEY = 'ftue-video-last-seen-version';

/**
 * Check if user should see the FTUE video based on version tracking
 * @param gameConfig - Game configuration containing toggle and version
 * @returns true if video should be shown, false otherwise
 */
export const shouldShowFTUEVideo = (gameConfig: GameConfig): boolean => {
  console.log('shouldShowFTUEVideo', gameConfig);
  try {
    // 1. Check if toggle is explicitly OFF (undefined defaults to true for backward compatibility)
    const isEnabled = gameConfig.showOnboardingVideo ?? true;

    if (!isEnabled) {
      return false;
    }

    // 2. Check if video exists
    if (!gameConfig.ftueVideo?.url) {
      return false;
    }

    // 3. Get current version from backend (default to 1)
    const currentVersion = gameConfig.ftueVideoVersion ?? 1;
    console.log('currentVersion', currentVersion);

    // 4. Get last seen version from localStorage
    const lastSeenVersionStr = localStorageService.load(
      FTUE_VERSION_STORAGE_KEY,
    );
    const lastSeenVersion = lastSeenVersionStr
      ? parseInt(lastSeenVersionStr, 10)
      : null;
    console.log('lastSeenVersion', lastSeenVersion);

    // 5. Show video if user hasn't seen THIS version
    // null = never seen, or last seen version < current version
    return lastSeenVersion === null || lastSeenVersion < currentVersion;
  } catch (error) {
    console.error('Error checking FTUE video version:', error);
    // Fail safe: don't show video on error
    return false;
  }
};

/**
 * Mark FTUE video as seen for a specific version
 * @param ftueVideoVersion - The version number that was just watched
 */
export const markFTUEVideoAsSeen = (ftueVideoVersion: number): void => {
  try {
    localStorageService.save(
      FTUE_VERSION_STORAGE_KEY,
      ftueVideoVersion.toString(),
    );
    console.log(`✅ FTUE video v${ftueVideoVersion} marked as seen`);
  } catch (error) {
    console.error('Error marking FTUE video as seen:', error);
  }
};
